<template lang="pug">
.input_wrap
  .input_wrapper(
    :class='getClass',
    :style='getStyle',
    @click.stop.prevent='focusInput',
    ref='input_wrapper'
  )
    input.input(
      :name='name',
      :type='getInputType',
      v-model='inputData',
      @input='emitThis',
      @change='$emit("change", $event)',
      :placeholder='placeholder',
      @focus='inputFocus = true',
      @blur='blur',
      @keyup='keyUp',
      :ref='inputRef',
      :autocomplete='autocomplete'
    )
    //костыль, так как этот файл все равно удалять, нет смысла пока что делать нормально
    .eye.svg_position(v-if='search', @click='emitThis')
      AppSvgIcon(
        v-if='closedPassword',
        :template='$ui.IconSvgComponents.searchGlass',
        :size='"100"'
      )
    template(v-if='isPassword')
      .eye.svg_position(@click='closedPassword = !closedPassword')
        AppSvgIcon(
          v-if='closedPassword',
          :template='$ui.IconSvgComponents.eye',
          :size='"100"'
        )
        AppSvgIcon(
          v-else,
          :template='$ui.IconSvgComponents.closedEye',
          :size='"100"'
        )
    template(v-else-if='!!hint')
      .question.svg_position(@click='openThisHint')
        AppSvgIcon.question_icon(
          :template='$ui.IconSvgComponents.question',
          :color-mode='"stroke"',
          :size='"100"'
        )
      .hint(v-if='openHint', tabindex=-1, @click.stop.prevent='')
        info
        p {{ hint }}
        .close(@click='closeThisHint')
          close
    template(v-else)
      AppSvgIcon.apply(
        :color-mode='"stroke"',
        :template='$ui.IconSvgComponents.apply',
        v-if='checkAllError === false',
        :size='"100"'
      )
      AppSvgIcon.alert(
        :color-mode='"stroke"',
        :template='$ui.IconSvgComponents.alert',
        v-if='checkAllError === true',
        :size='"100"'
      )
  .errorText(v-if='checkAllError && errorText') {{ errorText }}
</template>

<script>
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
export default {
  name: 'AppInput',
  components: { AppSvgIcon },
  props: {
    name: {
      type: String,
    },
    search: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    mask: String,
    regex: String,
    validator: {},
    hint: String,
    isPassword: Boolean,
    formatter: {},
    errorText: String,
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: undefined,
    },
    checkForm: {
      type: Boolean,
      default: false,
    },
    saveMask: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'on',
    },
  },
  data() {
    return {
      input: this.value || '',
      isError: null,
      inputFocus: false,
      inputRef: 'inputRef',
      openHint: false,
      closedPassword: true,
    };
  },
  computed: {
    checkAllError() {
      if (this.valid !== undefined) {
        if (this.valid === null) {
          return null;
        }
        return this.valid === false;
      } else {
        if (this.error === true || this.isError === true) {
          return true;
        } else if (this.isError === null) {
          return null;
        } else {
          return this.error || this.isError;
        }
      }
    },
    getQuestionStroke() {
      if (this.openHint) {
        return '#279DF2';
      } else {
        return '';
      }
    },
    getInputType() {
      if (!this.isPassword || !this.closedPassword) {
        return 'text';
      } else {
        return 'password';
      }
    },
    inputData: {
      get() {
        return this.input;
      },
      set(data) {
        let emit = data;
        if (this.formatter) {
          emit = this.formatter(emit);
        }
        this.input = emit;
      },
    },
    getClass() {
      if (this.checkAllError === true) {
        return 'error';
      } else if (this.checkAllError === false) {
        return 'success';
      } else {
        return '';
      }
    },
    getStyle() {
      return {
        '--ui_app_input_border': !this.inputFocus
          ? '1px solid #B6B6B6'
          : '1px solid #279DF2',
        '--question_style': this.getQuestionStroke,
      };
    },
  },
  watch: {
    checkForm(value) {
      if (value) {
        this.checkError();
      }
    },
    value(value) {
      if (this.value !== value) {
        this.inputData = value;
      }
    },
  },
  mounted() {
    if (this.mask || this.regex) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const Inputmask = require('inputmask');
      const im = Inputmask.default({
        mask: this.mask ? this.mask : undefined,
        regex: this.regex ? this.regex : undefined,
      });
      im.mask(this.$refs.inputRef);
    }
    if (document) {
      document.addEventListener('click', this.closeThisHint);
    }
  },
  methods: {
    keyUp(event) {
      this.$emit('keyup', event);
    },
    unMusk(data) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const Inputmask = require('inputmask');
      return Inputmask.default.unmask(data, {
        mask: this.mask ? this.mask : undefined,
        regex: this.regex ? this.regex : undefined,
      });
    },
    emitThis() {
      let emitData = this.input;
      if (this.mask && !this.saveMask) {
        emitData = this.unMusk(emitData);
      }
      this.$emit('input', emitData);
    },
    focusInput(event) {
      this.$refs.inputRef.focus();
    },
    checkError() {
      if (this.validator) {
        this.isError = !this.validator(this.input);
        this.$emit('validate', !this.isError);
      }
    },
    blur() {
      this.inputFocus = false;
      this.checkError();
      this.$emit('blur');
    },
    openThisHint() {
      this.openHint = true;
    },
    closeThisHint() {
      this.openHint = false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/uikit/stylus/index'
.errorText {
  font-size: 11px;
  color #F01F51
}
.input_wrap {
  width 240px
  display flex
  flex-direction column
}
.question
  cursor pointer
  .question_icon
    color var(--question_style)
.svg_position {
  position absolute;
  right 7px;
}
.hint {
  padding: 10px;
  font-weight: 400;
  font-size: 12px;
  left 0
  z-index 100
  display flex
  position absolute
  width inherit
  background: #F4F4F4;
  top 40px
  p {
    flex 1;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.eye {
  width 17.86px;
  height 16px;
  cursor pointer;
}
.close {
  cursor pointer
}
.input_wrapper {
  position relative
  cursor: text;
  display flex;
  align-items center
  background: #F4F4F4
  width: 100%;
  height: 40px;
  border: var(--ui_app_input_border);
  border-radius: 6px;
  &:hover {
    background #FFFFFF
  }
  .input {
    padding-left 13px;
    outline: none;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    color: #000000;
    background inherit
    border: none;
    padding-right: 31px;
    width: 100%;
    height 100%;
    border-radius: 6px;
  }
}
.alert {
  color #F01F51
  width: 17.86px;
  height: 16px;
  position: absolute;
  right: 9px;
}

.apply {
  color #54CB6E
  height: 10px;
  width: 14px;
  position: absolute;
  right: 9px;
}
.input_wrapper.success {
  border: 1px solid #54CB6E;
}
.input_wrapper.error {
  border: 1px solid #F01F51;
}
</style>



// WEBPACK FOOTER //
// AppInput.vue?2a22dbcc